/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const publicChallengeClipItemSchema = z.object({
  id: z.number(),
  transcript: z.string().nullable(),
  durationMs: z.number(),
  startMs: z.number().nullable(),
  endMs: z.number().nullable(),
  updatedAt: z.number().nullable(),
  verticalUrl: z.string().nullable(),
  baseUrl: z.string().nullable(),
});

export type IPublicChallengeClipItem = z.infer<typeof publicChallengeClipItemSchema>;

export const listPublicChallengeClipsBySlugV1ResponseDataSchema = z.array(
  publicChallengeClipItemSchema,
);

export type IListPublicChallengeClipsBySlugV1ResponseData = z.infer<
  typeof listPublicChallengeClipsBySlugV1ResponseDataSchema
>;

export const listPublicChallengeClipsBySlugV1ResponseSchema = createApiResponseSchema(
  listPublicChallengeClipsBySlugV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IListPublicChallengeClipsBySlugV1ResponseData>>;

export type IListPublicChallengeClipsBySlugV1Response =
  IAPI<IListPublicChallengeClipsBySlugV1ResponseData>;
